import { ReduxStore } from 'store/types';

function editCompanyIsLoading(state: ReduxStore): boolean {
  return state.auth.editCompany.config.isLoading;
}

export default editCompanyIsLoading;
